import { render, staticRenderFns } from "./number-span.vue?vue&type=template&id=607e6bc6&scoped=true&"
import script from "./number-span.vue?vue&type=script&lang=ts&"
export * from "./number-span.vue?vue&type=script&lang=ts&"
import style0 from "./number-span.vue?vue&type=style&index=0&id=607e6bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607e6bc6",
  null
  
)

export default component.exports